'use client';

import FadeIn from '@/components/animations/FadeIn';
import commonStyles from '@/app/(website)/commonStyles.module.scss';
import styles from './calculatorPage.module.scss';
import { getCalculatorBySlug } from '@/services/cms';
import { cx } from 'class-variance-authority';
import BlockRendererClient from '@/components/BlocksRendererClient';
import RelatedCalcCard from './components/RelatedCalcCard';
import FAQ from '@/components/FAQ';
import ResourcesBreadcrumb from '@/components/ResourcesBreadcrumb';
import CalculatorByType from './components/CalculatorByType';

export default function CalculatorPage({
  data
}: {
  data: NonNullable<Awaited<ReturnType<typeof getCalculatorBySlug>>>;
}) {
  const { calculator } = data;

  return (
    <div className={styles.wrapper}>
      <section
        className={cx(styles.calculatorPage, commonStyles.sectionContent)}
      >
        <FadeIn yShift={0}>
          <div className={styles.breadcrumb}>
            <ResourcesBreadcrumb
              category="TOOLS & CALCULATORS"
              categoryHref="/resources/tools-calculators"
              itemClassName={commonStyles.sectionSubheadingH7}
            />
          </div>
          <h1
            className={cx(styles.sectionHeading, commonStyles.sectionHeading)}
          >
            {calculator?.header}
          </h1>
          <p
            className={cx(
              styles.sectionSubheading,
              commonStyles.sectionSubheadingH5
            )}
          >
            {calculator?.description}
          </p>
        </FadeIn>
        <FadeIn>
          <div className={styles.calculatorContainer}>
            <CalculatorByType type={calculator?.calculator?.calculator_type} />
          </div>
        </FadeIn>
        <FadeIn>
          <div className={styles.descriptionContainer}>
            {calculator?.description_blocks && (
              <BlockRendererClient content={calculator?.description_blocks} />
            )}
          </div>
        </FadeIn>
        <FadeIn>
          <FAQ className={styles.faq} faq_entry={calculator?.FAQ || []} />
        </FadeIn>
        <FadeIn>
          <h2
            className={cx(
              styles.relatedCalcsHeading,
              commonStyles.sectionSubheadingH2
            )}
          >
            Explore more financial tools
          </h2>
          <div className={styles.relatedCalcs}>
            {calculator?.calculator_links?.map((calculator) => (
              <RelatedCalcCard key={calculator?.slug} data={calculator!} />
            ))}
          </div>
        </FadeIn>
      </section>
    </div>
  );
}
